import type { Theme } from '../types/theme';

export const setWindowTheme = (theme: Theme) => {
  document.documentElement.setAttribute('data-theme', theme);
};
